import { render, staticRenderFns } from "./funnelIcon.vue?vue&type=template&id=ef9a3e3a&"
import script from "./funnelIcon.vue?vue&type=script&lang=js&"
export * from "./funnelIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports